import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const CRMAuthContext = createContext();

const API = process.env.REACT_APP_BACKEND_URL;

export const CRMAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('crm_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchCurrentUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchCurrentUser = async () => {
    try {
      const response = await axios.get(`${API}/api/crm/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data.user);
      setCompany(response.data.company);
    } catch (error) {
      console.error('Auth error:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/api/crm/auth/login`, {
      email,
      password
    });
    
    const { token: newToken, user: userData, company: companyData } = response.data;
    
    localStorage.setItem('crm_token', newToken);
    setToken(newToken);
    setUser(userData);
    setCompany(companyData);
    
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('crm_token');
    setToken(null);
    setUser(null);
    setCompany(null);
  };

  const isAdmin = () => user?.role === 'admin';
  const isManager = () => ['admin', 'manager'].includes(user?.role);

  return (
    <CRMAuthContext.Provider value={{
      user,
      company,
      token,
      loading,
      login,
      logout,
      isAdmin,
      isManager,
      isAuthenticated: !!token && !!user
    }}>
      {children}
    </CRMAuthContext.Provider>
  );
};

export const useCRMAuth = () => {
  const context = useContext(CRMAuthContext);
  if (!context) {
    throw new Error('useCRMAuth must be used within CRMAuthProvider');
  }
  return context;
};

export default CRMAuthContext;
